import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {documentFind, documentTransferStore} from '../../features/dashboard/DocumentTransferSlice'
import {findCustomer, mobileVerificationCode} from '../../features/dashboard/CustomerSlice'
import Loading from '../../Loading';
import Broadcast from './Broadcast';
import Header from './Header';
import { ToastContainer, toast } from 'react-toastify';
import Message from '../form/Message'

function DocumentTransfer () {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const documentId = useRef('')
    const previousId = useRef('')
    const [response, setResponse] = useState(false)
    const [name, setName] = useState('')
    const [family, setFamily] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const [numberType, setNumberType] = useState('')
    const [number, setNumber] = useState('')
    const [father, setFather] = useState('')
    const [idcard, setIdcard] = useState('')
    const [mobile, setMobile] = useState('')
    const [phone, setPhone] = useState('')
    const [address, setAddress] = useState('')
    const [postalcode, setPostalcode] = useState('')
    const [birthplace, setBirthplace] = useState('')
    const [placeofissue, setPlaceofissue] = useState('')
    const [birthregistrationdate, setBirthregistrationdate] = useState('')
    const [customerType, setCustomerType] = useState('')
    const [customerNumber, setCustomerNumber] = useState('')
    let { loading, message, success, status } = useSelector(state => state.documentTransfer);
    const { 
        customerLoading, 
        customerMessage, 
        customerSuccess, 
        customerStatus, 
        customer,
        errorCustomerType,
        errorCustomerNumber,
        customerVerificationCode,
        verificationCodeMessage,
        errorVerificationCode
     } = useSelector(state => state.customer);
    const {
        customerStore,
        documentRow,
        errorName,
        errorFamily,
        errorNationalCode,
        errorNumberType,
        errorNumber,
        errorFather,
        errorBirthplace,
        errorIdcard,
        errorBirthregistrationdate,
        errorPlaceofissue,
        errorMobile,
        errorPostalcode,
        errorPhone,
        errorAddress
    } = useSelector(state => state.documentTransfer)
    const [image, setImage] = useState()

    const customerSearchHandler = () => {
        const data = {
            'type': customerType,
            'number': customerNumber
        }
        dispatch(findCustomer(data))
    }

    const documentTransferStoreHandler = (event) => {
        event.preventDefault()
        const data = {
            'documentId': documentId.current.value,
            'previousId': previousId.current.value,
            'name': name,
            'family': family,
            'nationalCode': nationalCode,
            'father': father,
            'idcard': idcard,
            'mobile': mobile,
            'phone': phone,
            'address': address,
            'postalcode': postalcode,
            'birthplace': birthplace,
            'placeofissue': placeofissue,
            'birthregistrationdate': birthregistrationdate,
        } 
        dispatch(documentTransferStore(data));
    }
    const documentFindHandler = (event) => {
        event.preventDefault()
        setResponse(true)
        const data = {
            'numberType': numberType,
            'number': number
        } 
        
        dispatch(documentFind(data));
    }
    const newDocumentRequestHandler = (event) => {
        event.preventDefault()
        window.location.reload(false);
        navigate('/dashboard/document/transfer')
    }
    const documentPrintHandler = (event) => {
        event.preventDefault()
        window.print()

    }
    useEffect(() => {
        if(loading === false && success === true) {
            setNumberType('')
            setNumber('')

            loading === false ?

                toast.success(message,{
                    position: "top-center",
                    autoClose: 1200,
                }) :
                toast.error(message,{
                position: "top-center",
                autoClose: 1200,
                });
            message = ''
        }
        
    },[loading,success,response])
    
    const handleChangeImage = (e) => {
        setImage(e.target.files[0])
        const formData = new FormData()
        formData.append('file', image)
        console.log(200)
    }

    const handleSubmitFile = (e) => {
        console.log(image)
        console.log(300)
        dispatch()
    }

    return (
        <>
        { loading ? ( <Loading /> ) : null}
        <Broadcast title={'مدیریت مشتریان'} />
            {/* <div className='bg-white'>
                <div className="mb-3">
                    <label htmlFor="formFile" className="form-label">Default file input example</label>
                    <input 
                        className="form-control" 
                        type='file' 
                        name='file' 
                        id="formFile"
                        onChange={(e) => handleChangeImage(e)} />
                </div>
                <button onClick={(e) => handleSubmitFile()}>submit</button>
            </div>   */}
        <div className="text-end" style={{direction:'rtl'}}>
            {
                (Object.keys(documentRow).length != 0 && response === true) ? (
                <>
                <div className='row g-2 p-5 my-5 print-position'>  
                    <Header title='اطلاعات انبار' />  
                    <div className='col-4 col-md-4 p-3 list-group list-group-flush d-flex flex-column justify-content-around align-items-center border font'>
                        <input type="hidden" ref={documentId} value={documentRow.id} />
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center fs-5">
                            <div className="fw-bold"> شماره پلاک : </div>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                            <span className="px-3 border-bottom border-dark">{documentRow.mt_pelakserial}</span>
                            <span className="px-3">
                                {documentRow.mt_pelakno}
                            </span>
                            </div>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center fs-5">
                            <div className="fw-bold"> تاریخ نصب : </div>
                            <span className="px-3">{documentRow.mt_pelakdate}</span>
                        </li>
                    </div>
                    <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> نوع کاربری : </div>
                            <span className="px-3">{documentRow.tp_karbari}</span>
                        </li>
                        
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> سیستم : </div>
                            <span className="px-3">{documentRow.tp_system}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تیپ : </div>
                            <span className="px-3">{documentRow.tp_tip}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> رنگ : </div>
                            <span className="px-3">{documentRow.cl_name}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> مدل : </div>
                            <span className="px-3">{documentRow.mt_model}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  شماره بدنه  : </div>
                            <span className="px-3">
                                {documentRow.mt_bodyno}
                            </span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> شماره انجین : </div>
                            <span className="px-3">
                                {documentRow.mt_motorno}
                            </span>
                        </li>
                    </div>
                    <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تعداد محور : </div>
                            <span className="px-3">{documentRow.tp_mehvar}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تعداد چرخ : </div>
                            <span className="px-3">{documentRow.tp_charkh}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  ظرفیت : </div>
                            <span className="px-3">{documentRow.tp_zarfiyat}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تعداد سیلندر : </div>
                            <span className="px-3">{documentRow.tp_cylandr}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> نوع سوخت : </div>
                            <span className="px-3">{documentRow.tp_sookht}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> حجم سیلندر : </div>
                            <span className="px-3">{documentRow.tp_hajm}</span>
                        </li>
                    </div>
                </div>
                <div className='row g-2 p-5 my-5'> 
                    <Header title={'مشخصات مالک'} /> 
                    <div className="col-7 col-md-8 p-3 list-group list-group-flush border">
                        {/* <input type="hidden" ref={previousId} value={documentRow.customer_data.id} /> */}
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> نام نام خانوادگی : </div>
                            <span className="px-3">{
                            documentRow.customer_data.name+' '+documentRow.customer_data.family}</span>
                        </li>
                        
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> نام پدر : </div>
                            <span className="px-3">{documentRow.customer_data.father_name}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> محل ثبت تولد : </div>
                            <span className="px-3">{documentRow.customer_data.birthplace}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> آدرس محل سکونت : </div>
                            <span className="px-3">{documentRow.customer_data.address}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  شماره شناسنامه / ملی: </div>
                            <span className="px-3">{documentRow.customer_data.nationalCode}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  کد پستی  : </div>
                            <span className="px-3">
                                {documentRow.customer_data.postalcode}
                            </span>
                        </li>
                    </div>
                    <div className="col-5 col-md-4 p-3 list-group list-group-flush border">
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تاریخ ثبت تولد : </div>
                            <span className="px-3">{documentRow.customer_data.birthdaye}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  ثبت / شماره شناسنامه : </div>
                            <span className="px-3">{documentRow.customer_data.idcard}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> ثبت / محل صدور : </div>
                            <span className="px-3">{documentRow.customer_data.placeofissue}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تلفن ثابت : </div>
                            <span className="px-3">{documentRow.customer_data.phone}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> شماره موبایل : </div>
                            <span className="px-3">
                                {documentRow.customer_data.mobile}
                            </span>
                        </li>
                    </div>
                </div>
                {
                (success === true && customerStore === true) ? (
                    <div className='row g-2 p-5 my-5'> 
                    <Header title={'مشخصات خریدار'} /> 
                    <div className="col-7 col-md-8 p-3 list-group list-group-flush border">
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> نام نام خانوادگی : </div>
                            <span className="px-3">{name+' '+family}</span>
                        </li>
                        
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> نام پدر : </div>
                            <span className="px-3">{father}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> محل ثبت تولد : </div>
                            <span className="px-3">{birthplace}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> آدرس محل سکونت : </div>
                            <span className="px-3">{address}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  شماره شناسنامه / ملی: </div>
                            <span className="px-3">{nationalCode}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  کد پستی  : </div>
                            <span className="px-3">
                                {postalcode}
                            </span>
                        </li>
                    </div>
                    <div className="col-5 col-md-4 p-3 list-group list-group-flush border">
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تاریخ ثبت تولد : </div>
                            <span className="px-3">{birthregistrationdate}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold">  ثبت / شماره شناسنامه : </div>
                            <span className="px-3">{idcard}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> ثبت / محل صدور : </div>
                            <span className="px-3">{placeofissue}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> تلفن ثابت : </div>
                            <span className="px-3">{phone}</span>
                        </li>
                        <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                            <div className="fw-bold"> شماره موبایل : </div>
                            <span className="px-3">
                                {mobile}
                            </span>
                        </li>
                    </div>
                    <div>
                        <div className="mb-3">
                            <label htmlFor="formFile" className="form-label">Default file input example</label>
                            <input 
                                className="form-control" 
                                type="file" 
                                name='file' 
                                id="formFile"
                                onChange={handleChangeImage} />
                        </div>
                        <button onClick={handleSubmitFile}>submit</button>
                    </div>
                    </div>
                ) : null
                }
                </>
                ) : null   
            }
            
            {
                (customerStore === true && success === true) ? (
                    null
                ) : (
                    <>
                    {
                        (customerStore === false && success === true) ? (
                            <div className='row g-2 p-5 my-5 print-position'>
                                <Header title={'درخواست مشتری'} />
                                <div className="col-12">
                                    <div className='row'>
                                        <div className="col-6">
                                            <div className="row m-3">
                                                <label 
                                                    htmlFor="staticEmail" 
                                                    className="text-end fw-bold form-label px-1">
                                                    انتخاب نوع جستجو
                                                </label>
                                                <select 
                                                    style={{marginBottom: '2px'}}
                                                    value={customerType}
                                                    defaultValue={'DEFAULT'}
                                                    tabIndex="4"
                                                    onChange={(e) => setCustomerType(e.target.value)}
                                                    className="form-control form-select form-select-lg shadow-none" 
                                                    aria-label="form-select-lg example">
                                                    <option value='DEFAULT' selected>یک مورد را انتخاب کنید</option>
                                                    <option value='mobile'>شماره موبایل</option>
                                                    <option value='nationalId'>شماره ملی</option>
                                                </select>
                                                {
                                                    (errorCustomerType) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorCustomerType }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row m-3">
                                                <label htmlFor="staticEmail" className="text-end fw-bold form-label px-1">
                                                    ثبت شماره موبایل یا شماره ملی 
                                                </label>                            
                                                <input
                                                    tabIndex="5" 
                                                    type="text" 
                                                    value={customerNumber}
                                                    onChange={(e) => setCustomerNumber(e.target.value)}
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="staticEmail" 
                                                    placeholder='12345678' 
                                                />
                                                {
                                                    (errorCustomerNumber) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorCustomerNumber }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        
                                    </div>
                                    { 
                                      
                                            <Message message={customerMessage} />
                                     
                                    } 
                                </div>   
                                <div className="row g-2 px-0 mb-3">
                                    <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                                        <button 
                                            tabIndex='6'
                                            onClick={customerSearchHandler}
                                            type="submit"
                                            className="print-no position-relative px-4 py-1 btn btn-dark fw-bold">
                                            <span style={{paddingRight: '20px'}}>
                                            {'  جستجوی مشتری  '}
                                            <i className="fa-solid fa-arrow-left fa-rotate-by fa-fw fa-stack fa-lg"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div> 
                            </div>
                        ) : null
                    }
                    <div className='row g-2 p-5 my-5'>
                        {
                            (Object.keys(documentRow).length == 0 && response === false) ? (
                                <Header title={'انتقال سند'} />
                            ) : null
                            // (
                            //     (customerStore === false) ? (
                            //         <Header title={'مشخصات خریدار'} />
                            //     ) : null
                            // )
                        }
                        {
                            
                        (Object.keys(documentRow).length == 0 && status === false) ? (
                            <div className="col-12">
                                <div className='row'>
                                    <div className="col-6">
                                        <div className="row m-3">
                                            <label 
                                                htmlFor="staticEmail" 
                                                className="text-end form-label px-1">
                                                انتخاب نوع شماره
                                            </label>
                                            <select 
                                            style={{marginBottom: '2px'}}
                                                value={numberType}
                                                defaultValue={'DEFAULT'}
                                                tabIndex="1"
                                                onChange={(e) => setNumberType(e.target.value)}
                                                className="form-control form-select form-select-lg shadow-none" 
                                                aria-label="form-select-lg example">
                                                <option value='DEFAULT' selected disabled>یک مورد را انتخاب کنید</option>
                                                <option value='mt_pelakno'>شماره پلاک</option>
                                                <option value='mt_bodyno'>شماره شاسی</option>
                                                <option value='mt_sanadno'>شماره سند</option>
                                            </select>
                                            {
                                                (errorNumberType) ? (
                                                <span className="help-block fw-bold d-inline-block mt-2">
                                                    <small className='text-danger validate-error'>{ errorNumberType }</small>
                                                </span>
                                            ):''}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="row m-3">
                                            <label htmlFor="staticEmail" className="text-end form-label px-1">
                                                ثبت شماره پلاک یا شماره شاسی 
                                            </label>                            
                                            <input
                                                tabIndex="2" 
                                                type="text" 
                                                value={number}
                                                onChange={(e) => setNumber(e.target.value)}
                                                className="form-control form-control-lg shadow-none" 
                                                id="staticEmail" 
                                                placeholder='12345678' 
                                            />
                                            {
                                                (errorNumber) ? (
                                                <span className="help-block fw-bold d-inline-block mt-2">
                                                    <small className='text-danger validate-error'>{ errorNumber }</small>
                                                </span>
                                            ):''}
                                        </div>
                                    </div>
                                    {message ? (<strong className='m-3 mb-0'>{message}</strong>) : null}
                                </div>
                            </div> 
                        ): (
                        <>
                            {
                                (customerStore === false && success === true) ? (
                                <>
                                
                                    <Header title={'مشخصات خریدار'} />
                                    <div className="col-6 ">
                                        <div className="col-12 ">
                                            <div className="row m-3">
                                                <label htmlFor="staticEmail" className="text-end form-label px-1">
                                                    نـــام
                                                </label>
                                                    <input
                                                        tabIndex="3" 
                                                        type="text"
                                                        value={name ? name : customer.name} 
                                                        onChange={(e) => setName(e.target.value)}
                                                        className="form-control form-control-lg shadow-none" 
                                                        id="staticEmail" 
                                                        placeholder="مثال : محمد" 
                                                        autoFocus
                                                    />
                                                    {
                                                        (errorName) ? (
                                                        <span className="help-block fw-bold d-inline-block mt-2">
                                                            <small className='text-danger validate-error'>{ errorName }</small>
                                                        </span>
                                                    ):''}
                                            </div>
                                        </div>
                                        <div className="col-12 ">
                                            <div className="row m-3">
                                                <label htmlFor="staticEmail" className="text-end form-label px-1">
                                                نـــام خانوادگی
                                                </label>
                                                <input
                                                    tabIndex="4" 
                                                    type="text"
                                                    value={family ? family : customer.family}
                                                    onChange={(e) => setFamily(e.target.value)} 
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="staticEmail" 
                                                    placeholder="مثال : ناصری" 
                                                />
                                                {
                                                    (errorFamily) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorFamily }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        <div className="col-12 ">
                                            <div className="row m-3">
                                                <label htmlFor="father" className="text-end form-label px-1">
                                                نـــام پدر
                                                </label>
                                                <input
                                                    tabIndex="5" 
                                                    type="text"
                                                    value={father ? father : customer.father_name}
                                                    onChange={(e) => setFather(e.target.value)} 
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="father" 
                                                    placeholder="مثال : ناصری" 
                                                />
                                                {
                                                    (errorFather) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorFather }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="row m-3">
                                                <label htmlFor="nationalCode" className="text-end form-label px-1">
                                                شماره/شناسه ملی
                                                </label>
                                                <input
                                                    tabIndex="6" 
                                                    type="text" 
                                                    value={nationalCode ? nationalCode : customer.nationalCode}
                                                    onChange={(e) => setNationalCode(e.target.value)}
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="nationalCode" 
                                                    placeholder="12345678" 
                                                />
                                                {
                                                    (errorNationalCode) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorNationalCode }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="row m-3">
                                                <label htmlFor="mobile" className="text-end form-label px-1">
                                                تلفن همراه
                                                </label>
                                                <input
                                                    tabIndex="7" 
                                                    type="text" 
                                                    value={mobile ? mobile : customer.mobile}
                                                    onChange={(e) => setMobile(e.target.value)}
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="mobile" 
                                                    placeholder="0912XXX1221" 
                                                />
                                                {
                                                    (errorMobile) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorMobile }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="row m-3">
                                                <label htmlFor="phone" className="text-end form-label px-1">
                                                تلفن
                                                </label>
                                                <input
                                                    tabIndex="8" 
                                                    type="text" 
                                                    value={phone ? phone : customer.phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="mobile" 
                                                    placeholder="021874XXXX" 
                                                />
                                                {
                                                    (errorPhone) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorPhone }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>  
                                    </div>
                                    <div className="col-6 ">
                                        <div className="col-12">
                                            <div className="row m-3">
                                                <label htmlFor="birthplace" className="text-end form-label px-1">
                                                محل ثبت تولد
                                                </label>
                                                <input
                                                    tabIndex="9" 
                                                    type="text" 
                                                    value={birthplace ? birthplace : customer.birthplace}
                                                    onChange={(e) => setBirthplace(e.target.value)}
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="birthplace" 
                                                    placeholder="تهران" 
                                                />
                                                {
                                                    (errorBirthplace) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorBirthplace }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>  
                                        <div className="col-12 ">
                                            <div className="row m-3">
                                                <label htmlFor="Birthregistrationdate" className="text-end form-label px-1">
                                                    تاریخ ثبت تولد
                                                </label>
                                                    <input
                                                        tabIndex="10" 
                                                        type="number"
                                                        value={birthregistrationdate ? birthregistrationdate : customer.birthregistrationdate} 
                                                        onChange={(e) => setBirthregistrationdate(e.target.value)}
                                                        className="form-control form-control-lg shadow-none" 
                                                        id="birthregistrationdate" 
                                                        placeholder="73" 
                                                    />
                                                    {
                                                        (errorBirthregistrationdate) ? (
                                                        <span className="help-block fw-bold d-inline-block mt-2">
                                                            <small className='text-danger validate-error'>{ errorBirthregistrationdate }</small>
                                                        </span>
                                                    ):''}
                                            </div>
                                        </div>
                                        <div className="col-12 ">
                                            <div className="row m-3">
                                                <label htmlFor="idcard" className="text-end form-label px-1">
                                            شماره شناسنامه / ثبت
                                                </label>
                                                <input
                                                    tabIndex="11" 
                                                    type="number"
                                                    value={idcard ? idcard : customer.idcard}
                                                    onChange={(e) => setIdcard(e.target.value)} 
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="idcard" 
                                                    placeholder="0371" 
                                                />
                                                {
                                                    (errorIdcard) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorIdcard }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        <div className="col-12 ">
                                            <div className="row m-3">
                                                <label htmlFor="father" className="text-end form-label px-1">
                                                محل صدور
                                                </label>
                                                <input
                                                    tabIndex="12" 
                                                    type="text"
                                                    value={placeofissue ? placeofissue : customer.placeofissue}
                                                    onChange={(e) => setPlaceofissue(e.target.value)} 
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="father" 
                                                    placeholder="تهران" 
                                                />
                                                {
                                                    (errorPlaceofissue) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorPlaceofissue }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="row m-3">
                                                <label htmlFor="postalcode" className="text-end form-label px-1">
                                                کد پستی
                                                </label>
                                                <input
                                                    tabIndex="13" 
                                                    type="number" 
                                                    value={postalcode ? postalcode : customer.postalcode}
                                                    onChange={(e) => setPostalcode(e.target.value)}
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="postalcode" 
                                                    placeholder="21888-12233" 
                                                />
                                                {
                                                    (errorPostalcode) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorPostalcode }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div> 
                                        <div className='col-12'>
                                            <div className="row m-3">
                                                <label htmlFor="Birthregistrationdate" className="text-end form-label px-1">
                                                    آدرس محل سکونت
                                                </label>
                                                <input
                                                    tabIndex="14" 
                                                    type="text" 
                                                    value={address ? address : customer.address}
                                                    onChange={(e) => setAddress(e.target.value)}
                                                    className="form-control form-control-lg shadow-none" 
                                                    id="address" 
                                                    placeholder="تهران خیابان کوجه مرکزی پلاک 21" 
                                                />
                                                {
                                                    (errorAddress) ? (
                                                    <span className="help-block fw-bold d-inline-block mt-2">
                                                        <small className='text-danger validate-error'>{ errorAddress }</small>
                                                    </span>
                                                ):''}
                                            </div>
                                        </div> 
                                    </div>
                                </>
                                ) : (
                                    null
                                )
                            }
                        </>
                        )
                    }
                    </div>
                    </>
                )
            }
            {
                (documentRow.length != 0) ? (
                <div className="row g-2 px-0 mb-5">
                    <div className="mx-1 col-6 col-md-12 d-flex justify-content-end me-auto mb-5">
                    {
                        (customerStore === false) ? (
                        <button 
                            tabIndex='15'
                            onClick={documentTransferStoreHandler}
                            type="submit"
                            className="print-no order-1 px-4 mx-3 py-1 btn btn-dark fw-bold">
                            <span style={{paddingRight: '20px'}}>
                            {' انتقال سند'}
                            <i className="fa-solid fa-arrow-left fa-rotate-by fa-fw fa-stack fa-lg"></i>
                            </span>
                        </button>
                        ) : (
                        <button 
                            onClick={() => setResponse(false)}
                            type="submit"
                            className="print-no position-relative mx-3 px-4 py-1 btn btn-outline-dark fw-bold">
                            <span style={{paddingRight: '20px'}}>
                            {'درخواست سند'}
                            <i className="fa-solid fa-refresh fa-rotate-by fa-fw fa-stack fa-lg"></i>
                            </span>
                        </button>
                        )
                    }
            {
                (customerStore === true && success === true) ? (
                    <button 
                        onClick={documentPrintHandler}
                        type="submit"
                        className="print-no position-relative px-4 py-1 btn btn-outline-dark fw-bold">
                        <span style={{paddingRight: '20px'}}>
                        {'  چاپ سند موقت  '}
                        <i className="fa-solid fa-print fa-fw fa-stack fa-lg"></i>
                        </span>
                    </button>
                ) : null
            }
                    </div>
                </div>
                ) : (
                <div className="row g-2 px-0 mb-5">
                    {
                        (documentRow.length == 0 && success === true && customerStore === true) ? (
                        <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto mb-5">
                            <button 
                                tabIndex='6'
                                onClick={newDocumentRequestHandler}
                                type="submit"
                                className="print-no position-relative px-4 py-1 btn btn-dark fw-bold">
                                <span style={{paddingRight: '20px'}}>
                                {'  جستجوی مجدد  '}
                                <i className="fa-solid fa-arrow-left fa-rotate-by fa-fw fa-stack fa-lg"></i>
                                </span>
                            </button>
                        </div>
                        ) : (
                            <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                                <button 
                                    tabIndex='6'
                                    onClick={documentFindHandler}
                                    type="submit"
                                    className="print-no position-relative px-4 py-1 btn btn-dark fw-bold">
                                    <span style={{paddingRight: '20px'}}>
                                    {'  جستجوی سند  '}
                                    <i className="fa-solid fa-arrow-left fa-rotate-by fa-fw fa-stack fa-lg"></i>
                                    </span>
                                </button>
                            </div>
                        )
                    }
                    
                </div>
                )
            }   
            
        </div>
        </>
    )
}

export default DocumentTransfer;